import { useSong } from '@church/data'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { SongPage } from '../components/services/SongPage.tsx'
import { useBreadcrumbs } from '../lib/breadcrumbs.ts'

/** One song: its details and arrangements. */
export const Route = createFileRoute('/_authed/_shell/services/_sections/songs/$songId/')({
  component: SongScreen,
})

function SongScreen() {
  const { songId } = Route.useParams()
  const navigate = useNavigate()
  // The song's own title: a phone's top bar names it (bold), the tab says it too.
  const title = useSong(songId).data?.title
  useBreadcrumbs([{ label: 'Songs', href: '/services/songs' }, { label: title ?? 'Song' }])
  return (
    <SongPage
      key={songId}
      songId={songId}
      arrangementId=""
      openArrangement={(arrangementId) =>
        void navigate(
          arrangementId
            ? {
                to: '/services/songs/$songId/arrangements/$arrangementId',
                params: { songId, arrangementId },
              }
            : { to: '/services/songs/$songId', params: { songId } },
        )
      }
      onDeleted={() => void navigate({ to: '/services/songs' })}
    />
  )
}
